import { Box, makeStyles, Typography } from '@material-ui/core'
import React from 'react'

const FAKE_PREVIOUS_PRICE: Array<number> = [230, 265, 250, 245]

interface PriceProps{
  trainerId: string;
  value: number;
}

const useStyles = makeStyles(({typography, palette})=>({
  crossed: {
    ...typography.subtitle1,
    textDecoration: 'line-through',
  },
  discountPrice: {
    ...typography.subtitle1,
    color: palette.success.main
  }
}))

const getFakePreviousPrice = (trainerId:string) => {
  const localStorageKey = `previous_price:${trainerId}`
  const priceFromStorage = localStorage.getItem(localStorageKey)
  if(priceFromStorage){
    return Number(priceFromStorage)
  }
  const fakePriceItem = FAKE_PREVIOUS_PRICE[Math.floor(Math.random() * FAKE_PREVIOUS_PRICE.length)];
  localStorage.setItem(localStorageKey, `${fakePriceItem}`);
  return fakePriceItem
}

export const Price: React.FC<PriceProps> = ({value, trainerId}) => {
  const classes = useStyles()
  const crossed =classes.crossed
  const [fakePreviousPrice, setFakePreviousPrice] = React.useState<number>()

  React.useEffect(() => {
    setFakePreviousPrice(getFakePreviousPrice(trainerId))
  }, [])

  return (
    <Box>
      <Typography className={crossed} variant="subtitle1">
        {`CA$${fakePreviousPrice}/month`}
      </Typography>
      <Typography className={classes.discountPrice}>
        {`CA$${value}/month`}
      </Typography>
    </Box>
  )
}